<template>
  <div class="login">
     <Title titleName='设置账号' iconLeft="back"/>



	<div class="login_user" >
		<div class="user_input">
			
		<div> </div> <input v-model="ruleForm.alipay_account" placeholder="请输入账号" />
		</div>
	<div class="user_input">
		
	<div> </div> <input v-model="ruleForm.alipay_name" placeholder="请输入姓名" />
	</div>
	
		
		
	
	</div>

	<div class="login_bt">
	
		<van-button color="#FF5E00"   @click="loginForm()" block>确定</van-button>
	</div>
	
	
	
	
	
	
  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast } from 'vant';	
export default {
  components: {
    Title
  },
  data() {
    return {
		active: 1,
		id:'',
		file:'',
	
		ruleForm:{
			alipay_account:'',
			alipay_name:''
			
		}
    
    };
  },mounted() {
  	this.id = this.$route.query.id

  },methods:{
	loginForm(){
				
				if(this.ruleForm.alipay_account	 == ''){
				
					Toast('请输入账号');
					return
				}
			
				
				
			this.$axios({
			      method: "post",
			      url: "stores/edit",
			      data: this.ruleForm,  
			    }).then((res) => {
			    	let data=res.data;
			    			
			    	if(data.code==200){
									
						
						Toast(data.message);
				
			    		
			    	}else{  
									Toast(data.message);
									      
								}
			     
			    });
				
				
				
				
			
			}
  }
};
</script>
<style lang="scss" scoped>

.login{
	width: 100%;
	height: 100%;
	background: #FFFFFF;
	.logo{
		width: 266px;
		height: 156px;
		margin: 150px;
	}
	
	.login-button {
	  background: #F8F8F8;
	
	  .han{
		  background: #6DAD19;
	  }
	 
	}
	
	.login_user{
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}
.login_bt{
		
		width: 631px;
		margin: 50px auto;
		padding-bottom: 90px;
	
	}
	.login_at{
			display: flex;
			width: 631px;
			margin: 50px auto;
			justify-content: space-between;
		
		}
	.login_user .user_input{
		width: 591px;
		padding: 0 20px;
		color: #000000;
		font-size: 28px;
		height: 90px;
		border-bottom: 1px solid #DDDDDD;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		margin-top: 40px;
		span{
			color: #E72E34;
			margin-left: 10px;
			
		}
		.ip{
			color: #F29F25;
		}
	
	}
	.login_user .user_input .input_icon{
		width: 39px;
		height: 46px;
		margin-right: 22px;
		margin-left: 16px;
	}
	.login_user .user_input input{
		flex: 1;
		height: 46px;
		font-size: 22px;
		color: #6d6d6d;
		background:none;  
		outline:none;  
		border:none;
	}
	.login_user .user_input input:focus{  
		border:none;
	}
	.login_user .user_input .show_pwd_icon{
		width: 32px;
		height: 20px;
		cursor: pointer;
		margin-left: 65px
	}
}
 .pro-tit{
	 background: #FFFFFF;
	 text-align: center;
	 line-height: 40px;
	 padding: 50px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	 .it1{
		 width: 130px;
		 margin-bottom: 20px;
	 }
	 .it2{
		 width: 300px;
	 }
 }
 .fiv-ind{
	ul{
		display: flex;
		justify-content: space-evenly;
		
		li{
			font-size: 34px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #222222;
		}
		.han{
			color: #FF5E00;
			border-bottom:4px solid #FF5E00 ;
			padding-bottom: 10px;
		}
	}
	 

 }
</style>